export default __webpack_public_path__ + "static/media/2.ec111f65.jpg";